export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
  AUDIO = 'AUDIO',
}

/** The media types `./Creations` can be narrowed to. */
export type CreationsMediaType =
  | MediaType.IMAGE
  | MediaType.VIDEO
  | MediaType.AUDIO;

/**
 * What `./Creations`' type filter can show — the host's `?type=` values, so
 * they cross the federation boundary as plain strings.
 */
export type CreationsFilter = 'all' | 'image' | 'video' | 'audio';

export const MEDIA_TYPE_BY_CREATIONS_FILTER: Record<
  Exclude<CreationsFilter, 'all'>,
  CreationsMediaType
> = {
  image: MediaType.IMAGE,
  video: MediaType.VIDEO,
  audio: MediaType.AUDIO,
};

export enum PreviewMediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export interface BaseMedia {
  src: string;
  height?: number;
  width?: number;
}

export interface IVideo extends BaseMedia {
  poster?: string;
  duration?: number;
}

export interface IImage extends BaseMedia {
  alt?: string;
}

export type FlowMedia = {
  id: string;
  url: string;
  width?: number;
  height?: number;
  type: MediaType;
  driveUid?: string;
  poster?: string;
};
